// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d09855c","455":"bb2833ef","977":"76b4ef55"}[chunkId] + ".chunk.js";
};